module.exports = __webpack_public_path__ + "media/images/favicon-73c710692e63b8e1a1b316e784b50e40.ico";